import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";
export const SummaryWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${COLORS.cirrus_black1};
  border: 1px solid ${COLORS.cirrus_black3};
  border-radius: 12px;
  padding: 24px 16px;
  gap: 24px;
  flex-wrap: wrap;

  ${responsive.MOBILE`
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 16px 12px;
  `}
`;

export const VerticalDivider = styled.div`
  height: 70px;
  border-left: 1px dashed #bdbdbd;

  ${responsive.MOBILE`
    height: 1px;
    width: 100%;
    border-left: none;
    border-top: 1px dashed #bdbdbd;
    margin: 16px 0;
  `}
`;
